<template>
  <NuxtLayout name="seminar-lp-for1-column">
    <template #title>
      <span style="font-size:1rem;">{{ isReBroadcasted ? '＜再配信＞' : '' }}【{{pageTitleTarget}}】</span>
      <h1>{{ pageTitle }}</h1>
      <v-chip v-for="tag in seminarVar.tags" :class="`${tag.class} ma-2`" label v-text="tag.name" />
    </template>
    <template #terminated>
      <div v-show="isExpiredApply" style="background-color:#aeaeae;">このセミナーは終了しました</div>
    </template>
    <template #main-visual>
      <v-img width="100%" heghit="100%" :aspect-ratio="960/540" preload contain class="mv mx-auto" :src="`/img/${route.path.replace(/^\//, '')}/mv.webp`" type="image/webp" alt="セミナー">
        <source width="960" heghit="540" :srcset="`/img/${route.path.replace(/^\//, '')}/mv.png`" type="image/png" />
      </v-img>
    </template>
    <template #detail>
      <component v-html="seminarVar.summary" />
      <dl>
        <dt>
          <h3>主催</h3>
        </dt>
        <dd v-html="seminarVar.host" />
      </dl>
      <dl>
        <dt>
          <h3>日時</h3>
        </dt>
        <!-- TODO: 書き換える -->
        <!-- <dd>{{getDateStringJP(eventStartDateTime)}}～{{getDateStringJP(eventEndDateTime, true)}}</dd> -->
        <dd>以下の日程のいずれもご参加いただけます。（内容は変わりません）</dd>
        <dd>2025/12/10（水） 12:00～13:00</dd>
        <dd>　　　　　　　　  19:00～20:00</dd>
        <!-- TODO: End of 書き換える -->
      </dl>
      <dl>
        <dt>
          <h3>申込期日</h3>
        </dt>
        <!-- TODO: 書き換える -->
        <!-- <dd>{{getDateStringJP(eventExpiresApplyDateTime)}}</dd> -->
        <dd>2025/12/10（水） 18:50</dd>
        <!-- TODO: End of 書き換える -->
      </dl>
      <dl>
        <dt>
          <h3>参加対象者</h3>
        </dt>
        <dd>
          <ul>
            <li v-for="target in seminarVar.targets" v-html="target" />
          </ul>
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>会場</h3>
        </dt>
        <dd>
          {{seminarVar.isOnline ? 'オンライン' : seminarVar.place}}
          <ul class="notice" v-if="seminarVar.isOnline">
            <li>当日の参加URLはオンラインセミナー当日までにメールにてお知らせいたします。</li>
            <li>
              ご視聴の環境により、セミナーのご視聴ができない可能性がございます。<br />
              その場合、申込完了後のメールに記載しているメールアドレスまでご連絡ください。
            </li>
          </ul>
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>注意事項</h3>
        </dt>
        <dd>
          <ul class="notice">
            <li v-for="caution in seminarVar.cautions" v-text="caution" />
          </ul>
        </dd>
      </dl>
      <h3>登壇者</h3>
      <AppCardSpeakerCard v-for="speaker in speakers" :speaker="speaker" />
    </template>
    <template #form>
      <AppForm202512SeminarStepForm class="mx-auto" :isExpiredApply="isExpiredApply" :seminarVar="seminarVar" />
    </template>
    <template #floating-navigation>
      <AppFloatingButtonsGoToApplication v-if="isExpiredApply === false" targetQuerySelector="#application" :targetElementTopOffset="-64" />
    </template>
  </NuxtLayout>
</template>
<script setup lang="ts">
import type { Speaker } from '@/types/person';
import { getDateTimeString, getDateString, getDateStringJP } from '@/utils/Date';
import seminarVar from '@/assets/seminar/202512.json';

const route = useRoute();
const runtimeConfig = useRuntimeConfig();

const isReBroadcasted : boolean = seminarVar.isReBroadcasted;
const pageTitleTarget : string = seminarVar.title.target;
const pageTitle : string = seminarVar.title.name;
const pageDescription : string = seminarVar.description;

const eventStartDateTimeString: string = seminarVar.schedule.start;
const eventEndDateTimeString: string = seminarVar.schedule.end;

const eventStartDateTime: Date = new Date(eventStartDateTimeString);
const eventEndDateTime: Date = new Date(eventEndDateTimeString);
const eventExpiresApplyDateTime: Date = new Date(eventStartDateTime.getFullYear(), eventStartDateTime.getMonth(), eventStartDateTime.getDate(), eventStartDateTime.getHours(), eventStartDateTime.getMinutes() - 10, eventStartDateTime.getSeconds());

const isExpiredApply: boolean = (new Date()).getTime() > eventExpiresApplyDateTime.getTime();
const speakers : Speaker[] = ((speakers) => (speakers.map(((speaker) => (
  {
    ...speaker,
    name: `${speaker.name} 氏`,
    image: {
      alt: `講師 ${speaker.name} 氏`,
      proper: {
        src: `/img/${route.path.replace(/^\//, '')}/${speaker.image.filename}.jpg`,
        type: 'image/jpg',
      },
      webp: {
        src: `/img/${route.path.replace(/^\//, '')}/${speaker.image.filename}.webp`,
        type: 'image/webp',
      },
    },
  }
)))))(seminarVar.speakers);

definePageMeta({
  isr: {
    revalidate: 3600,
  }
});

useHead({
  link: [
    {
      rel: 'preload',
      fetchpriority: "high",
      type: "image/png",
      href: `/img/${route.path.replace(/^\//, '')}/mv.png`,
      as: 'image',
    },
    {
      rel: 'preload',
      fetchpriority: "high",
      type: "image/webp",
      href: `/img/${route.path.replace(/^\//, '')}/mv.webp`,
      as: 'image',
    },
    {
      rel: 'canonical',
      href: `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
    },
  ],
  script: [
    // TODO: 書き換える
    {
      type: 'application/ld+json',
      textContent: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Event",
        "name": `${eventStartDateTime.getFullYear()}年${eventStartDateTime.getMonth() + 1}月セミナー｜${isReBroadcasted ? '＜再配信＞' : ''}【${pageTitleTarget}】${pageTitle}`,
        "description": pageDescription,
        "startDate": "2025-12-10T12:00+09:00",
        "endDate": "2025-12-10T13:00+09:00",
        "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",
        "eventStatus": "https://schema.org/EventScheduled",
        "location": {
          "@type": "VirtualLocation",
          "url": `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
        },
        "image": [
          `${runtimeConfig.public.appUrlOrigin}/img/${route.path.replace(/^\//, '')}/mv.png`,
        ],
        "offers": {
          "@type": "Offer",
          "url": `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
          "price": 0,
          "priceCurrency": "JPY",
          "availability": "https://schema.org/InStock",
        },
        "performer": speakers.map(speaker => ({
          "@type": "Person",
          "name": speaker.name,
        })),
        "organizer": {
          "@type": "Organization",
          "name": "C&Rリーガル･エージェンシー社",
          "url": "https://legal-agent.jp/",
        },
      }),
    },
    {
      type: 'application/ld+json',
      textContent: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Event",
        "name": `${eventStartDateTime.getFullYear()}年${eventStartDateTime.getMonth() + 1}月セミナー｜${isReBroadcasted ? '＜再配信＞' : ''}【${pageTitleTarget}】${pageTitle}`,
        "description": pageDescription,
        "startDate": "2025-12-10T19:00+09:00",
        "endDate": "2025-12-10T20:00+09:00",
        "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",
        "eventStatus": "https://schema.org/EventScheduled",
        "location": {
          "@type": "VirtualLocation",
          "url": `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
        },
        "image": [
          `${runtimeConfig.public.appUrlOrigin}/img/${route.path.replace(/^\//, '')}/mv.png`,
        ],
        "offers": {
          "@type": "Offer",
          "url": `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
          "price": 0,
          "priceCurrency": "JPY",
          "availability": "https://schema.org/InStock",
        },
        "performer": speakers.map(speaker => ({
          "@type": "Person",
          "name": speaker.name,
        })),
        "organizer": {
          "@type": "Organization",
          "name": "C&Rリーガル･エージェンシー社",
          "url": "https://legal-agent.jp/",
        },
      }),
    },
    // {
    //   type: 'application/ld+json',
    //   textContent: JSON.stringify({
    //     "@context": "https://schema.org",
    //     "@type": "Event",
    //     "name": `${eventStartDateTime.getFullYear()}年${eventStartDateTime.getMonth() + 1}月セミナー｜${isReBroadcasted ? '＜再配信＞' : ''}【${pageTitleTarget}】${pageTitle}`,
    //     "description": pageDescription,
    //     "startDate": formatDateWithTimezone(eventStartDateTime),
    //     "endDate": formatDateWithTimezone(eventEndDateTime),
    //     "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",
    //     "eventStatus": "https://schema.org/EventScheduled",
    //     "location": {
    //       "@type": "VirtualLocation",
    //       "url": `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
    //     },
    //     "image": [
    //       `${runtimeConfig.public.appUrlOrigin}/img/${route.path.replace(/^\//, '')}/mv.png`,
    //     ],
    //     "offers": {
    //       "@type": "Offer",
    //       "url": `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
    //       "price": 0,
    //       "priceCurrency": "JPY",
    //       "availability": "https://schema.org/InStock",
    //     },
    //     "performer": speakers.map(speaker => ({
    //       "@type": "Person",
    //       "name": speaker.name,
    //     })),
    //     "organizer": {
    //       "@type": "Organization",
    //       "name": "C&Rリーガル･エージェンシー社",
    //       "url": "https://legal-agent.jp/",
    //     },
    //   }),
    // },
  ],
});
useSeoMeta({
  title: `${isReBroadcasted ? '＜再配信＞' : ''}【${pageTitleTarget}】${pageTitle}`,
  description: pageDescription,
  keywords: seminarVar.keywords,
  ogUrl: `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
  ogTitle: `${isReBroadcasted ? '＜再配信＞' : ''}【${pageTitleTarget}】${pageTitle}`,
  ogDescription: pageDescription,
  ogImageUrl: `${runtimeConfig.public.appUrlOrigin}/img/${route.path.replace(/^\//, '')}/mv.png`,
});
</script>
